import immutable from 'immutable'
import { FLEETINVITE } from '../actiontype'
const defaultState = immutable.fromJS({
    //邀请链接
    fleetinvitelink : '',
})

export const fleetinviteReducer = (state = defaultState, action) => {
    switch (action.type) {
        case FLEETINVITE:
            return state.updateIn(['fleetinvitelink'], _ => (action.data))
        default:
            break;
    }
    return state
}
